import React, { useState, useEffect } from "react";
import axios from 'axios';
import './Navbar.css';
import logo from '../Assets/BGNoT.png';
import 'remixicon/fonts/remixicon.css';
import { Link } from "react-router-dom";
import ScrollReveal from 'scrollreveal';


const Navbar = () => {
    useEffect(() => {
        ScrollReveal().reveal('.nav-main', {
            delay: 200,
            duration: 2000,
            easing: 'ease-in-out',
            origin: 'right',
            reset: true
        });
    }, []);

    const [isNavMenuVisible, setNavMenuVisible] = useState(false);
    const [isSearchVisible, setSearchVisible] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [sneakers, setSneakers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const toggleNav = () => {
        setNavMenuVisible(!isNavMenuVisible);
    };

    const toggleSearch = () => {
        setSearchVisible(!isSearchVisible);
    };

    const handleSearch = async (query) => {
        if (!query) {
            setSneakers([]);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`https://sneakerxplore.onrender.com/search?query=${query}&filter=available`);
            setSneakers(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            setError('Error fetching data. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { value } = e.target;
        setSearchInput(value);
        handleSearch(value);
    };

    const handleClick = () => {
        handleSearch(searchInput);
    };

    return (
        <div className="nav-main">
            <header className="header" id="header">
                <nav className="nav container">
                    <Link to='/' className="logo m-0 float-start">
                        <div className="nav-logo">
                            <img src={logo} alt="logo" className="img-fluid" />
                        </div>
                    </Link>

                    <div className={`nav__menu ${isNavMenuVisible ? 'show-menu' : ''}`} id="nav-menu">
                        <ul className="nav__list">
                            <li className="nav__item">
                                <Link to='/' className="nav__link">Home</Link>
                            </li>
                            <li className="nav__item">
                                <Link to='/sneakers' className="nav__link">Sneakers</Link>
                            </li>
                            <li className="nav__item">
                                <Link to='/calendar' className="nav__link">Calendar</Link>
                            </li>
                            <li className="nav__item">
                                <Link to='/sneaker-news' className="nav__link">Sneaker News </Link>
                            </li>
                        </ul>

                        <div className="nav__close" id="nav-close" onClick={toggleNav}>
                            <i className="ri-close-line"></i>
                        </div>
                    </div>

                    <div className="nav__actions">
                        <i className="nav__icon" onClick={toggleSearch}>
                            <i className="ri-search-line nav__search" id="search-btn"></i>
                        </i>

                        <div className="nav__toggle" id="nav-toggle" onClick={toggleNav}>
                            <i className="ri-menu-line"></i>
                        </div>
                    </div>
                </nav>
            </header>

            <div className="underText">
                <h2>"Step In Style"</h2>
            </div>

            {isSearchVisible && (
                <div className="search show-search" id="search">
                    <div className="search__close" id="search-close" onClick={toggleSearch}>
                        <i className="ri-close-line"></i>
                    </div>
                    <form action="" className='search__form'>
                        <i className='ri-search-line search__icon' onClick={handleClick}>
                          
                        </i>
                        <input
                            className='search__input'
                            type="search"
                            placeholder="What are you looking for?"
                            value={searchInput}
                            onChange={handleChange}
                        />
                    </form>

                    {loading && <p>Loading...</p>}
                    {error && <p>{error}</p>}
                    <div className='sneaker-list'>
                        {sneakers.length > 0 ? (
                            sneakers.map(sneaker => (
                                <div key={sneaker.id} className='sneaker-card'>
                                    <Link to={`/sneaker/${sneaker.slug}/${sneaker.id}`} onClick={toggleSearch}>
                                        <h4 className='sneaker-search-name'>{sneaker.name}</h4>
                                        <img src={sneaker.image_url} alt={sneaker.name} />
                                    </Link>
                                </div>
                            ))
                        ) : (
                            !loading && <p>No sneakers found.</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Navbar;
